import MainLayout from '@/common/components/layouts/MainLayout';
import { VehicleImagePreview } from '@/modules/adjusterReportModules/adjusterReport/pages/ImagePreview/vehicleImagePreview';
import { ADJUSTER_REPORT_BODY_DAMAGE_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/bodyDamage/bodyDamageLinks';
import { useNavigate, useParams } from 'react-router-dom';

export default function () {
  const { id } = useParams();
  const navigate = useNavigate();
  const navigateToRepeatCapturing = () => {
    navigate(
      ADJUSTER_REPORT_BODY_DAMAGE_LINKS.BODY_DAMAGE_IMAGES({
        id: id!,
      }).ADJUSTER_VEHICLE.damagedPoints,
      { replace: true },
    );
  };
  const BackToImagesTab = () => {
    navigate(
      ADJUSTER_REPORT_BODY_DAMAGE_LINKS.BODY_DAMAGE_IMAGES({
        id: id!,
      }).adjusterImagesTabsPage,
      { replace: true },
    );
  };
  return (
    <MainLayout title="بیمه گذار / تصاویر" header="onlyTitleHeader">
      <VehicleImagePreview
        BackToImagesTab={BackToImagesTab}
        navigateToRepeatCapturing={navigateToRepeatCapturing}
        userType="body"
      />
    </MainLayout>
  );
}
